import ApplicationSerializer from "./application";

export default class InstanceDatabaseSerializer extends ApplicationSerializer {
  primaryKey = "databaseid";
}
